import { useAtom } from '@reatom/npm-react'
import { AnimatePresence } from 'motion/react'
import { useMemo } from 'react'
import styled from 'styled-components'

import { capitalize } from '@root/shared/core/StringUtil'
import { useTranslation } from '@root/shared/localization'
import { Dialog, Input, SearchIcon } from '@root/shared/ui-kit'

import { reatomFollowingsFilter } from '../../atoms'
import { userConnectionsFollowingsModal } from '../../atoms/user-connections-followings-modal'

import { UserConnectionsFollowersListModal } from './user-connections-followers-list-modal'

import type { DelugeId } from '@root/entities/user-short'

export const UserConnectionsFollowingsModal = () => {
  const { t } = useTranslation()
  const [modal, setModal] = useAtom(userConnectionsFollowingsModal)

  const title = capitalize(
    modal
      ? [t('common.following_other'), `(${modal.followings})`].join(' ')
      : t('common.following_other'),
  )

  return (
    <AnimatePresence>
      {modal ? (
        <Dialog
          describedBy={title}
          open={!!modal}
          onOpenChange={() => setModal(undefined)}
        >
          <Dialog.Header title={title} />
          <UserConnectionsFollowingsFilter
            onNavigateToProfile={() => setModal(undefined)}
            delugeId={modal.delugeId}
          />
        </Dialog>
      ) : undefined}
    </AnimatePresence>
  )
}

type UserConnectionsFollowingsFilterProps = {
  delugeId: DelugeId
  onNavigateToProfile: () => void
}

export const UserConnectionsFollowingsFilter = ({
  delugeId,
  onNavigateToProfile,
}: UserConnectionsFollowingsFilterProps) => {
  const { t } = useTranslation()

  const followingsFilter = useMemo(
    // eslint-disable-next-line @reatom/unit-naming-rule
    () => reatomFollowingsFilter(delugeId),
    [delugeId],
  )

  const [searchQuery, setSearchQuery] = useAtom(
    followingsFilter.searchQueryAtom,
  )

  return (
    <Root>
      <Head>
        <Input
          size="m"
          startContent={<Icon size={16} />}
          value={searchQuery}
          onChange={(s) => setSearchQuery(s.target.value)}
          placeholder={t('common.username')}
        />
      </Head>
      <UserConnectionsFollowersListModal
        onNavigateToProfile={onNavigateToProfile}
        followersFilter={followingsFilter}
      />
    </Root>
  )
}

const Icon = styled(SearchIcon)`
  color: var(--text-9);
`

const Root = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  padding: 0 16px 12px;
  overflow: auto;
  width: 440px;
  min-height: 460px;
`

const Head = styled.div`
  z-index: 1;
  position: sticky;
  top: 0;
  padding: 12px 0;
  background: inherit;
`
